import { render, staticRenderFns } from "./BlockType107.vue?vue&type=template&id=d0413b4a&scoped=true"
import script from "./BlockType107.vue?vue&type=script&lang=ts"
export * from "./BlockType107.vue?vue&type=script&lang=ts"
import style0 from "./BlockType107.vue?vue&type=style&index=0&id=d0413b4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0413b4a",
  null
  
)

export default component.exports